export default __webpack_public_path__ + "static/media/radpad-left.1de1caa7.png";